import { Icon, type IconName } from '@/components/ui/icon.js';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: IconName;
  title: string;
  body?: string;
  action?: ReactNode;
}

export function EmptyState({ icon = 'search', title, body, action }: EmptyStateProps) {
  return (
    <div className="rounded-xl bg-[var(--bg-raised)] py-12 px-6 text-center flex flex-col items-center gap-3">
      <div className="w-14 h-14 rounded-full bg-[var(--bg-elevated)] grid place-items-center text-[var(--text-muted)]">
        <Icon name={icon} size={28} />
      </div>
      <div className="text-[15px] font-bold text-[var(--text-primary)]">{title}</div>
      {body && (
        <div className="text-[13px] text-[var(--text-secondary)] max-w-sm">{body}</div>
      )}
      {action}
    </div>
  );
}
